/* eslint-disable func-names */
import axios from '@/axios';

export const search = async ({ section, params }) => {
  try {
    const result = await axios(`/transporter/${section}/search`, { params });
    return result && result.data;
  } catch (error) {
    throw error;
  }
};

export const update = async ({ section, Id, data }) => {
  try {
    const result = await axios.put(`/transporter/${section}/${Id}`, { data });
    return result && result.data;
  } catch (error) {
    throw error;
  }
};

export const create = async ({ section, data }) => {
  try {
    const result = await axios.post(`/transporter/${section}`, { data });
    return result && result.data;
  } catch (error) {
    throw error;
  }
};

export const remove = async ({ section, data }) => {
  try {
    const result = await axios.delete(`/transporter/${section}/${data.id}`, { data });
    return result && result.data;
  } catch (error) {
    throw error;
  }
};
